module.exports = __webpack_public_path__ + "img/chef.b32c12e3.png";